<template>
  <div class="animated efficiency">

    <OrderTable
        :title="`${$t('pages.orders')}`"
        :headColumns="headColumns"
        :footColumns="footColumns"
        :rows="rows"
        :disableActionBTN="false"
        :key="'order-table-orders'"
        :isLoading="loading"
        @addReceipt="addReceipt"
        @changeVal="changeVal"
        @download="download"
        @downloadAll="downloadAll"
        @deleteChange="deleteChange"
        @uploadImage="uploadImage"
    ></OrderTable>
  </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  // import API from '../../../api/API'
  import Storage from '../../../api/Storage'
  import OrderTable from '../../../components/OrderTable'
  import { map, forEach, isEqual } from 'lodash'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'
  import moment from 'moment'

  export default {
    name: 'Orders',
    components: {
      Filters,
      OrderTable
    },
    props: {
      rowsOrder: Array,
      loading: Boolean
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          operatorFilter: true
        },
        form: {
          product: null,
          orders_count: null,
          price: null,
          provider: null,
          delivery_time: null,
          status: null,
          comment: null
        },
        isLoading: false,
        isBlock: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          // TODO Добавить переводы для названий
          {label: this.$root.$t('statistic.country'), field: 'country_id'},
          {label: this.$root.$t('statistic.product'), field: 'product_id'},
          {label: this.$root.$t('statistic.ordered'), field: 'orders_count', input: {type: 'number'}},
          {label: this.$root.$t('statistic.price'), field: 'price', input: {type: 'text'}},
          {label: this.$root.$t('statistic.provider'), field: 'provider'},
          {label: this.$root.$t('statistic.time'), field: 'delivery_time', input: {type: 'date'}},
          {label: this.$root.$t('statistic.status'), field: 'status', input: {type: 'selectStatus'}, color: [{value: 0, bg: '#fff9c4'}, {value: 1, bg: '#53d3a2'}]},
          {label: this.$root.$t('statistic.comment'), field: 'comment', input: {type: 'text'}}
        ],
        footColumns: {},
        rows: []
      }
    },
    created () {
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    watch: {
      rowsOrder: function (newq, old) {
        if (!isEqual(newq, old)) {
          this.calculateRows(newq)
        }
      }
    },
    methods: {
      calculateRows: function (rowsOrder) {
        this.rows = []
        map(rowsOrder, (item, index) => {
          const value = []
          let auxvalue
          forEach(this.headColumns, (headCol) => {
            if (headCol.field === 'price') {
              if (Storage.selectedCountry.id === -1) {
                if (item.country_id === 77 || item.country_id === 1535 || item.country_id === 1547) {
                  auxvalue = '₽'
                } else {
                  auxvalue = '$'
                }
              } else {
                if (Storage.selectedCountry.currency === 'RUB') {
                  auxvalue = Storage.selectedCountry.currency_symbol
                } else {
                  auxvalue = '$'
                }
              }
            } else if (headCol.field === 'orders_count') {
              auxvalue = 'шт.'
            } else {
              auxvalue = null
            }
            value.push({
              key: headCol.field,
              input: headCol.input ? headCol.input : null,
              value: item[headCol.field],
              color: headCol.color ? headCol.color : null,
              aux: auxvalue
            })
          })
          this.rows.push({
            key: item.id,
            value
          })
        })
      },
      clickAdd () {
        this.isBlock = !this.isBlock
      },
      addReceipt (id) {
        this.$emit('addReceipt', id)
      },
      uploadImage (id, files, name) {
        this.$emit('uploadImage', id, files, name)
      },
      download (id) {
        this.$emit('download', id)
      },
      downloadAll (row) {
        this.$emit('downloadAll', row.rows)
      },
      changeVal (key, cell) {
        if (cell.key === 'delivery_time') {
          cell.value = moment(cell.value).format('Y-MM-DD')
        }
        this.$emit('changeVal', { id: key, title: cell.key, value: cell.value })
      },
      deleteChange (id) {
        this.$emit('deleteChange', id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Orders.vue?6d0b74f2